import PropTypes from 'prop-types';
import React from 'react';

const CLang = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1112_10632)">
      <circle opacity="0.08" cx="1486" cy="663" r="124" fill="url(#paint0_linear_1112_10632)" />
      <circle opacity="0.08" cx="1486" cy="663" r="104" fill="url(#paint1_linear_1112_10632)" />
      <mask
        id="mask0_1112_10632"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1382"
        y="559"
        width="208"
        height="208"
      >
        <circle cx="1486" cy="663" r="104" fill="#181A1B" />
      </mask>
      <g mask="url(#mask0_1112_10632)">
        <g opacity="0.8">
          <path
            d="M1660.83 308.5L1593.57 347.33L1582.25 353.87L1570.6 360.59L1559.14 367.21L1547.57 373.89L1535.77 380.7L1524.2 387.38L1512.86 393.93L1501.29 400.61L1489.67 407.32L1478 414L1466.41 420.69L1454.81 427.38L1443.23 434.08C1439.36 436.3 1435.5 438.54 1431.64 440.76L1420.06 447.45L1408.48 454.14L1396.9 460.82L1385.31 467.51L1373.74 474.19L1362.15 480.88L1350.59 487.56L1339 494.29L1327.46 501L1315.88 507.68L1304.3 514.37L1292.74 521L1281.15 527.69L1269.58 534.38C1265.72 536.6 1261.86 538.84 1257.99 541.06L1246.42 547.75L1234.84 554.43L1223.26 561.12L1211.69 567.8L1200.1 574.5L1188.52 581.19L1176.94 587.87L1165.35 594.56L1153.77 601.25L1142.17 607.94L1130.57 614.64L1124.5 618.14"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1726.41 308.5L1626.41 366.26L1615 372.8L1603.35 379.53L1591.89 386.14L1580.32 392.82L1568.52 399.63L1557 406.31L1545.65 412.86L1534.08 419.54L1522.46 426.25L1510.82 433L1499.23 439.69L1487.63 446.39L1476.05 453.08L1464.46 459.76C1460.6 462 1456.74 464.23 1452.88 466.45L1441.3 473.14L1429.72 479.82L1418.13 486.51L1406.56 493.19L1395 499.85L1383.43 506.53L1371.85 513.22L1360.28 519.9C1356.42 522.127 1352.56 524.353 1348.69 526.58L1337.11 533.27L1325.53 540L1313.94 546.69L1302.37 553.37L1290.79 560L1279.21 566.68L1267.63 573.37L1256.05 580.05L1244.48 586.73L1232.9 593.42C1229.04 595.653 1225.18 597.88 1221.31 600.1L1209.73 606.8L1198.15 613.49L1186.56 620.19L1175 626.88L1163.4 633.57L1151.8 640.26C1147.9 642.5 1144.04 644.71 1140.22 646.7C1136.49 648.708 1132.6 650.423 1128.6 651.83C1127.25 652.291 1125.89 652.682 1124.5 653"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 714.37L1800.07 720.37L1788.48 727L1776.92 733.68L1765.33 740.37L1753.77 747.05C1749.9 749.27 1746.05 751.5 1742.18 753.74L1730.6 760.42L1719 767.14L1707.41 773.83L1695.84 780.51L1684.25 787.2L1672.68 793.87C1668.82 796.09 1664.96 798.283 1661.1 800.45C1657.24 802.6 1653.38 804.69 1649.52 806.79C1645.66 808.89 1641.85 811 1638 813C1634.15 815 1630.29 816.9 1626.42 818.87C1622.55 820.84 1618.71 822.87 1614.84 824.87C1610.97 826.87 1607.12 828.87 1603.26 831.01C1599.4 833.15 1595.53 835.28 1591.67 837.51C1587.81 839.74 1583.94 842.05 1580.08 844.44C1576.22 846.83 1572.34 849.33 1568.49 851.83L1556.89 859.36C1552.99 861.89 1549.12 864.36 1545.28 866.81C1541.44 869.26 1537.53 871.57 1533.71 873.86C1529.89 876.15 1525.95 878.52 1522.12 880.78C1518.29 883.04 1514.33 885.33 1510.51 887.53L1499 894.18L1487.5 900.82L1476 907.48L1464.27 914.25C1460.38 916.49 1456.54 918.71 1452.73 920.91L1441.28 927.52L1429.71 934.2L1418 940.93L1406.3 947.69C1402.39 949.95 1398.48 952.207 1394.56 954.46L1383.36 960.93L1325.36 994.44"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 676.5L1802 681.36L1790.42 688.05L1778.83 694.74L1767.25 701.42L1755.67 708.11L1744.1 714.79L1732.52 721.48L1721 728.16L1709.42 734.84L1697.84 741.53L1686.28 748.19C1682.41 750.423 1678.54 752.63 1674.68 754.81C1670.83 756.98 1666.98 759.11 1663.11 761.09C1659.24 763.07 1655.39 764.85 1651.53 766.44C1644.15 769.609 1636.35 771.732 1628.38 772.75C1624.52 773.29 1620.66 773.66 1616.79 773.89C1612.92 774.12 1609.09 774.22 1605.22 774.52C1601.33 774.802 1597.46 775.34 1593.64 776.13C1589.69 776.959 1585.81 778.048 1582 779.39C1578.05 780.793 1574.18 782.409 1570.41 784.23C1566.56 786.1 1562.69 788.23 1558.83 790.51C1554.97 792.79 1551.1 795.28 1547.24 798.03C1543.38 800.78 1539.5 803.85 1535.64 807.24C1531.78 810.63 1527.9 814.41 1524.05 818.39C1520.2 822.37 1516.28 826.68 1512.44 831.02C1508.6 835.36 1504.69 839.92 1500.86 844.11C1497.03 848.3 1493.11 852.32 1489.28 855.96C1485.45 859.6 1481.48 863.07 1477.67 866.13C1473.86 869.19 1469.97 872.04 1466.17 874.59C1462.37 877.14 1458.52 879.49 1454.67 881.79C1450.82 884.09 1447.06 886.27 1443.15 888.53C1439.24 890.79 1435.32 893.06 1431.42 895.31L1419.91 902L1408.46 908.61L1396.89 915.29L1385.23 922L1373.53 928.75L1361.79 935.53L1350.59 942L1259.76 994.45"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 498.71L1809.9 498.51C1806.15 497.023 1802.03 496.729 1798.11 497.67C1794.11 498.72 1790.3 501.3 1786.54 505.32C1782.78 509.34 1779 515 1775.2 521.07C1771.4 527.14 1767.57 533.68 1763.63 539.62C1760.18 544.933 1756.29 549.95 1752 554.62C1748.47 558.358 1744.57 561.731 1740.37 564.69C1736.52 567.44 1732.65 569.78 1728.77 572.08C1724.89 574.38 1721.05 576.59 1717.18 578.83L1705.59 585.53L1694 592.27L1682.43 599L1670.85 605.68C1666.98 607.91 1663.13 610.14 1659.26 612.36C1655.39 614.58 1651.53 616.79 1647.68 618.92C1643.83 621.05 1640 623 1636.11 624.78C1632.41 626.545 1628.52 627.887 1624.52 628.78C1620.71 629.538 1616.81 629.68 1612.96 629.2C1609.02 628.681 1605.14 627.793 1601.37 626.55C1597.59 625.201 1593.73 624.121 1589.8 623.32C1585.94 622.662 1581.97 622.905 1578.22 624.03C1573.97 625.389 1570.03 627.589 1566.64 630.5C1562.37 634.161 1558.5 638.252 1555.07 642.71C1551.22 647.57 1547.35 653.1 1543.49 658.71C1539.63 664.32 1535.78 669.98 1531.92 674.92C1528.36 679.486 1524.49 683.8 1520.33 687.83C1516.68 691.381 1512.82 694.701 1508.76 697.77C1504.9 700.68 1501.04 703.21 1497.18 705.62C1493.32 708.03 1489.46 710.3 1485.6 712.55C1481.74 714.8 1477.88 717 1474 719.27L1462.44 726L1450.86 732.69L1439.28 739.37L1427.69 746C1423.83 748.233 1419.97 750.463 1416.1 752.69C1412.23 754.93 1408.36 757.18 1404.51 759.25C1400.77 761.308 1396.89 763.116 1392.91 764.66C1389.22 766.177 1385.29 766.997 1381.3 767.08L1380.16 767.03"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 752.23L1809.71 752.66L1798.13 759.34L1786.56 766L1775 772.71L1763.41 779.39L1751.85 786.07L1740.26 792.76L1728.69 799.44L1717.11 806.13L1705.53 812.81L1693.95 819.5L1682.37 826.19L1670.79 832.86L1659.21 839.55L1647.64 846.23L1636 852.92L1624.42 859.61L1612.82 866.3L1601.26 873L1589.66 879.69L1578.05 886.4L1566.48 893.09L1554.9 899.77C1550.98 902.03 1547.1 904.28 1543.28 906.47L1531.78 913.11L1520.29 919.76C1516.49 921.94 1512.67 924.15 1508.76 926.41L1497 933.18L1485.46 939.84L1474 946.45L1462.44 953.13L1450.78 959.86L1439.07 966.62L1427.33 973.4L1416.13 979.86L1392.82 993.32"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 539.15L1807.99 543.15C1804.23 549.35 1800.37 555.74 1796.42 561.26C1792.98 566.143 1789.08 570.689 1784.79 574.84C1781.19 578.229 1777.3 581.294 1773.16 584C1769.31 586.57 1765.44 588.81 1761.56 591.07L1750 597.82L1738.41 604.51L1726.83 611.19C1722.97 613.43 1719.11 615.66 1715.25 617.88L1703.67 624.57L1692.09 631.25L1680.5 637.94L1668.93 644.61C1665.06 646.83 1661.2 649.04 1657.34 651.13C1653.48 653.22 1649.63 655.22 1645.78 656.94C1642.06 658.686 1638.18 660.059 1634.19 661.04C1630.4 661.925 1626.5 662.229 1622.62 661.94C1618.69 661.578 1614.8 660.865 1611 659.81C1607.13 658.81 1603.27 657.73 1599.41 657.07C1595.6 656.311 1591.67 656.29 1587.85 657.01C1583.66 658.009 1579.72 659.85 1576.26 662.42C1571.99 665.54 1568.11 669.152 1564.69 673.18C1560.83 677.59 1556.97 682.82 1553.1 688.25C1549.23 693.68 1545.39 699.31 1541.53 704.44C1537.94 709.258 1534.09 713.875 1530 718.27C1526.37 722.107 1522.51 725.707 1518.42 729.05C1514.71 732.082 1510.84 734.922 1506.84 737.56C1502.99 740.13 1499.13 742.48 1495.26 744.78C1491.39 747.08 1487.55 749.32 1483.69 751.56L1472.1 758.26L1460.48 765C1456.62 767.23 1452.76 769.46 1448.89 771.62C1445.02 773.78 1441.16 775.88 1437.3 777.57C1433.61 779.271 1429.71 780.481 1425.71 781.17C1424.92 781.29 1424.14 781.37 1423.36 781.43"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 600.17C1808.95 601.17 1807.44 602.17 1805.96 603.09C1802.1 605.52 1798.23 607.78 1794.36 610.09L1782.76 616.8L1771.17 623.49L1759.59 630.18L1748 636.82L1736.43 643.5L1724.84 650.19L1713.26 656.88L1701.68 663.55L1690.09 670.25L1678.53 676.92C1674.67 679.15 1670.8 681.39 1666.94 683.52C1663.08 685.65 1659.23 687.66 1655.37 689.52C1651.63 691.351 1647.76 692.912 1643.8 694.19C1640.05 695.396 1636.16 696.069 1632.22 696.19C1628.33 696.172 1624.44 695.716 1620.65 694.83C1616.79 694 1612.92 692.95 1609.06 692.13C1605.28 691.191 1601.39 690.81 1597.5 691C1593.44 691.415 1589.5 692.628 1585.91 694.57C1581.71 696.823 1577.82 699.61 1574.34 702.86C1570.19 706.755 1566.32 710.942 1562.76 715.39C1558.91 720.11 1555.04 725.29 1551.18 730.39C1547.32 735.49 1543.47 740.57 1539.6 745.15C1535.95 749.483 1532.08 753.622 1528 757.55C1524.32 761.1 1520.46 764.458 1516.43 767.61C1512.57 770.61 1508.71 773.29 1504.84 775.75C1500.97 778.21 1497.12 780.43 1493.25 782.54C1489.49 784.646 1485.62 786.549 1481.66 788.24L1480.71 788.63"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1775.09 482.27C1772.01 480.914 1768.68 480.232 1765.32 480.27C1761.32 480.46 1757.51 482.27 1753.75 485.33C1749.99 488.39 1746.22 492.95 1742.4 498.52C1738.58 504.09 1734.78 510.52 1730.83 516.76C1727.3 522.538 1723.42 528.095 1719.21 533.4C1715.73 537.645 1711.83 541.525 1707.57 544.98C1703.89 547.919 1700.03 550.621 1696 553.07C1692.14 555.48 1688.27 557.7 1684.41 559.94L1672.82 566.64L1661.24 573.33L1649.64 580C1645.77 582.21 1641.92 584.41 1638.06 586.54C1634.2 588.67 1630.33 590.76 1626.47 592.47C1622.74 594.145 1618.87 595.464 1614.89 596.41C1611.1 597.314 1607.21 597.674 1603.32 597.48C1599.37 597.16 1595.48 596.354 1591.73 595.08C1587.87 593.83 1584.01 592.25 1580.16 591.51C1576.32 590.748 1572.35 590.898 1568.58 591.95C1564.33 593.209 1560.39 595.337 1557 598.2C1552.71 601.839 1548.82 605.936 1545.42 610.42C1541.56 615.32 1537.7 620.94 1533.83 626.67C1529.96 632.4 1526.13 638.21 1522.27 643.23C1518.74 647.822 1514.87 652.138 1510.68 656.14C1507.05 659.633 1503.19 662.871 1499.11 665.83C1495.26 668.64 1491.4 671.06 1487.53 673.4C1483.66 675.74 1479.83 678 1476 680.27L1464.39 687L1452.8 693.69L1441.23 700.37L1429.65 707L1418.07 713.68L1406.48 720.37L1394.9 727.06L1383.31 733.75L1371.72 740.41C1367.83 742.64 1363.97 744.84 1360.12 746.75C1356.44 748.676 1352.55 750.144 1348.51 751.12C1344.84 751.926 1341.05 751.944 1337.37 751.17"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1675.24 459.479C1671.84 459.396 1668.46 459.907 1665.24 460.989C1661.12 462.437 1657.21 464.432 1653.62 466.919C1649.54 469.699 1645.66 472.756 1642 476.069C1638.15 479.509 1634.28 483.319 1630.41 486.829C1626.72 490.196 1622.85 493.351 1618.81 496.279C1615.15 498.937 1611.27 501.279 1607.22 503.279C1603.48 505.08 1599.61 506.601 1595.64 507.829C1591.77 509.059 1587.92 510.079 1584.06 511.149C1580.2 512.219 1576.34 513.339 1572.48 514.759C1568.49 516.224 1564.62 517.976 1560.89 519.999C1556.85 522.202 1552.98 524.699 1549.31 527.469C1545.21 530.573 1541.34 533.972 1537.73 537.639C1533.64 541.83 1529.77 546.232 1526.14 550.829C1522.28 555.649 1518.43 560.829 1514.58 565.829C1510.73 570.829 1506.85 575.659 1502.99 580.059C1499.37 584.241 1495.51 588.202 1491.42 591.919C1487.74 595.179 1483.88 598.224 1479.85 601.039C1475.99 603.779 1472.12 606.309 1468.26 608.709C1464.4 611.109 1460.56 613.379 1456.7 615.639L1445.11 622.349L1433.54 629.029L1422 635.739L1410.43 642.419L1398.85 649.109L1387.27 655.789C1383.41 658.009 1379.55 660.239 1375.7 662.479L1364.11 669.159L1352.53 675.849L1340.95 682.539L1329.36 689.219L1317.78 695.909L1306.18 702.599C1302.3 704.839 1298.43 707.069 1294.59 709.249C1290.75 711.429 1286.81 713.629 1282.98 715.379C1279.32 717.164 1275.42 718.407 1271.4 719.069C1268.01 719.538 1264.56 719.351 1261.24 718.519"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 335.721L1692 404.131L1680.67 410.661L1669 417.391L1657.51 424.001L1645.94 430.681L1634.15 437.481L1622.59 444.161L1611.24 450.651C1607.48 452.781 1603.62 454.971 1599.67 457.131C1595.72 459.291 1592 461.291 1588 463.401C1584 465.511 1580.27 467.561 1576.37 469.611C1572.47 471.661 1568.65 473.611 1564.77 475.681C1560.89 477.751 1557.05 479.821 1553.18 481.981C1549.31 484.141 1545.45 486.371 1541.59 488.681C1537.73 490.991 1533.87 493.381 1530.01 495.801C1526.15 498.221 1522.28 500.651 1518.43 503.081C1514.58 505.511 1510.7 507.911 1506.85 510.301C1503 512.691 1499.12 515.021 1495.26 517.301C1491.4 519.581 1487.53 521.941 1483.68 524.211C1479.83 526.481 1476 528.791 1472.15 531.001L1460.56 537.691L1449 544.391L1437.41 551.081L1425.84 557.771L1414.26 564.451L1402.68 571.141C1398.82 573.361 1394.98 575.591 1391.11 577.811L1379.53 584.501L1368 591.181L1356.41 597.871L1344.83 604.561L1333.26 611.241L1321.68 617.931L1310.1 624.611L1298.52 631.301L1286.9 638.001L1275.32 644.691L1263.73 651.381L1252.14 658.071L1240.55 664.761L1229 671.431C1225.1 673.691 1221.22 675.941 1217.39 678.041C1213.56 680.141 1209.64 682.191 1205.82 683.821C1202.15 685.505 1198.24 686.621 1194.23 687.131C1191.47 687.401 1188.69 687.198 1186 686.531"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1124.5 658.891C1130.02 661.521 1135.62 664.061 1141.19 666.561C1147.68 669.481 1154.19 672.361 1160.71 675.251C1166.71 677.931 1172.8 680.601 1178.83 683.321C1181.83 684.671 1184.83 686.031 1187.83 687.371C1190.83 688.711 1193.92 690.061 1196.98 691.371L1205.9 695.161L1215.19 699.161C1218.26 700.494 1221.33 701.791 1224.41 703.051C1227.41 704.321 1230.49 705.561 1233.53 706.821C1236.57 708.081 1239.7 709.381 1242.78 710.681C1245.86 711.981 1248.78 713.271 1251.78 714.561C1254.98 715.941 1258.19 717.307 1261.4 718.661C1264.3 719.881 1267.2 721.091 1270.08 722.341C1272.96 723.591 1275.54 724.741 1278.27 725.961C1281.42 727.371 1284.6 728.771 1287.77 730.151L1297.09 734.151L1306.41 738.241C1309.52 739.574 1312.63 740.907 1315.76 742.241C1318.7 743.501 1321.65 744.747 1324.6 745.981L1329.21 747.981C1330.65 748.581 1332.08 749.191 1333.53 749.751L1335.78 750.601L1338.22 751.521L1343.12 753.351L1352.71 756.941C1355.77 758.091 1358.84 759.261 1361.9 760.391C1364.96 761.521 1367.9 762.621 1370.9 763.701L1380.35 767.081C1383.5 768.211 1386.65 769.361 1389.8 770.481C1392.95 771.601 1396.17 772.741 1399.37 773.831C1402.57 774.921 1405.65 775.941 1408.8 776.971C1411.95 778.001 1414.87 778.971 1417.92 779.871"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1792 308.5L1659.15 385.19L1647.83 391.73L1636.18 398.46L1624.72 405.08L1613.15 411.75L1601.36 418.57L1589.79 425.24L1578.44 431.79L1566.88 438.47L1555.25 445.18L1543.61 451.9L1532 458.59L1520.41 465.29C1516.54 467.51 1512.67 469.74 1508.82 471.98L1497.24 478.67C1493.37 480.89 1489.51 483.13 1485.66 485.35L1474.09 492L1462.51 498.69L1450.93 505.38C1447.06 507.6 1443.2 509.823 1439.36 512.05L1427.77 518.75L1416.21 525.42L1404.62 532.11L1393.05 538.79L1381.47 545.48L1369.89 552.16L1358.32 558.84L1346.73 565.53L1335.17 572.21L1323.58 578.9L1312 585.62L1300.43 592.31L1288.85 599L1277.27 605.69L1265.69 612.37L1254.11 619.06C1250.25 621.28 1246.39 623.51 1242.53 625.75C1238.67 627.99 1234.81 630.22 1230.94 632.44L1219.35 639.13L1207.76 645.82L1196.16 652.52L1184.55 659.19C1180.65 661.43 1176.79 663.63 1172.97 665.52C1169.29 667.442 1165.41 668.945 1161.39 670C1157.59 670.984 1153.62 671.073 1149.78 670.26C1149.46 670.19 1149.15 670.11 1148.84 670.02"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1223.51 702.63C1224.65 702.92 1225.8 703.127 1226.97 703.25C1230.89 703.547 1234.84 703.051 1238.56 701.79C1242.56 700.487 1246.43 698.834 1250.13 696.85C1253.97 694.85 1257.85 692.61 1261.75 690.35C1265.65 688.09 1269.46 685.91 1273.34 683.68L1284.93 676.98L1296.52 670.29L1308.11 663.6L1319.69 656.91L1331.27 650.23L1342.85 643.54L1354.43 636.86L1366 630.18L1377.58 623.48L1389.15 616.81C1393.01 614.57 1396.88 612.34 1400.74 610.12L1412.31 603.44C1416.17 601.2 1420.04 598.97 1423.9 596.75L1435.46 590.07L1447.05 583.37C1450.9 581.14 1454.77 578.91 1458.62 576.63C1462.47 574.35 1466.33 572.03 1470.19 569.63C1474.05 567.23 1477.92 564.76 1481.78 562.14C1485.64 559.52 1489.48 556.78 1493.34 553.84C1497.2 550.9 1501.06 547.77 1504.93 544.38C1508.8 540.99 1512.64 537.38 1516.51 533.64C1520.38 529.9 1524.22 526.05 1528.09 522.24C1531.96 518.43 1535.81 514.66 1539.67 510.79C1543.53 506.92 1547.39 502.97 1551.25 499.37C1555.11 495.77 1558.96 492.56 1562.83 489.5C1566.7 486.44 1570.55 483.57 1574.41 481.02C1578.14 478.569 1582.01 476.335 1586 474.33C1589.52 472.525 1593.16 470.952 1596.88 469.62L1598.11 469.19C1601.11 468.19 1604.21 467.19 1607.27 466.38C1610.33 465.57 1613.19 464.87 1616.12 464.24C1618.01 463.85 1619.93 463.47 1621.82 463.14C1626.06 462.38 1630.4 461.74 1634.82 461.26C1637.15 461.01 1639.4 460.8 1641.73 460.63C1644.44 460.44 1647.21 460.28 1649.92 460.15H1650.33L1652.09 460.08C1652.67 460.08 1653.25 460.02 1653.83 459.99L1655.6 459.91C1658.69 459.77 1661.93 459.63 1665.03 459.54C1668.13 459.45 1671.03 459.43 1673.97 459.48C1675.53 459.48 1677.08 459.56 1678.63 459.63C1681.43 459.76 1684.26 459.97 1687.05 460.22C1689.84 460.47 1692.44 460.74 1695.1 461.04C1698.26 461.4 1701.38 461.8 1704.51 462.23C1707.8 462.7 1711.22 463.23 1714.51 463.78C1719.73 464.68 1725.44 465.78 1730.73 467.05"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1810.44 498.48C1805.99 496.48 1793.71 490.56 1781.44 485.07L1780.09 484.47L1776.54 482.9H1776.43L1775.89 482.66C1772.42 481.153 1768.93 479.7 1765.42 478.3C1760.22 476.233 1754.97 474.323 1749.67 472.57C1745.19 471.09 1740.32 469.57 1735.67 468.32L1732.67 467.55L1730.87 467.12C1727.62 466.26 1724.21 466.164 1720.92 466.84C1716.68 467.918 1712.77 470.05 1709.57 473.04C1705.24 476.992 1701.36 481.413 1698 486.22C1694.2 491.47 1690.32 497.6 1686.38 503.22C1682.54 508.72 1678.65 513.79 1674.74 518.37C1671.16 522.634 1667.29 526.644 1663.15 530.37C1659.49 533.553 1655.62 536.477 1651.55 539.12C1647.69 541.66 1643.83 543.96 1639.97 546.12C1636.11 548.28 1632.24 550.12 1628.38 551.9C1624.61 553.661 1620.74 555.21 1616.8 556.54C1613.02 557.758 1609.15 558.668 1605.22 559.26C1601.39 559.871 1597.52 560.165 1593.64 560.14C1589.76 560.071 1585.89 559.737 1582.06 559.14C1578.23 558.44 1574.37 557.999 1570.48 557.82C1566.54 557.829 1562.62 558.505 1558.9 559.82C1554.73 561.206 1550.83 563.296 1547.37 566C1543.07 569.547 1539.18 573.573 1535.79 578C1531.92 582.86 1528.07 588.45 1524.22 594.05C1520.37 599.65 1516.5 605.25 1512.64 610.24C1509.08 614.892 1505.21 619.298 1501.05 623.43C1497.44 626.999 1493.58 630.304 1489.49 633.32C1485.63 636.17 1481.76 638.65 1477.9 641.03C1474.04 643.41 1470.19 645.67 1466.33 647.93C1462.47 650.19 1458.61 652.41 1454.74 654.64L1443.18 661.32L1431.59 668L1420 674.73L1408.43 681.4L1396.85 688.09L1385.26 694.78C1381.41 697.013 1377.55 699.24 1373.68 701.46C1369.81 703.68 1365.94 705.91 1362.09 708.15L1350.51 714.85L1338.91 721.54C1335.03 723.78 1331.16 726.02 1327.32 728.09C1323.59 730.181 1319.71 731.99 1315.71 733.5C1312.02 734.93 1308.09 735.639 1304.13 735.59C1302.16 735.506 1300.2 735.197 1298.3 734.67"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1128.61 994.44L1285 904.13L1296.19 897.66L1307.93 890.89L1319.64 884.13L1331.3 877.4L1342.86 870.72C1346.73 868.48 1350.51 866.3 1354.31 864.04C1358.11 861.78 1361.96 859.42 1365.85 856.71C1370.03 853.85 1373.95 850.638 1377.58 847.11C1381.82 842.861 1385.67 838.246 1389.1 833.32C1392.95 827.88 1396.77 821.66 1400.6 815.48C1404.09 809.589 1407.94 803.912 1412.11 798.48C1415.33 794.325 1419.27 790.777 1423.73 788C1427.2 785.825 1431.21 784.671 1435.31 784.67C1436.77 784.712 1438.22 784.893 1439.64 785.21C1441.2 785.53 1442.77 785.84 1444.39 786.14C1447.39 786.69 1450.39 787.14 1453.39 787.55C1455.61 787.82 1457.86 788.05 1460.12 788.22C1462.38 788.39 1464.64 788.54 1466.96 788.64C1469.12 788.73 1471.22 788.79 1473.4 788.81C1477.21 788.81 1480.87 788.71 1484.66 788.43C1487.45 788.22 1490.14 787.95 1492.85 787.62C1495.77 787.28 1498.64 786.86 1501.33 786.39L1502.57 786.17C1505.05 785.71 1507.52 785.17 1509.82 784.61C1512.12 784.05 1514.24 783.43 1516.08 782.83C1517.64 782.32 1519.08 781.78 1520.23 781.34L1521.74 780.71C1523.49 779.94 1524.74 779.32 1526.07 778.64C1530.12 776.484 1534 774.006 1537.66 771.23C1541.53 768.34 1545.39 765.07 1549.25 761.58C1553.11 758.09 1556.97 754.36 1560.83 750.81C1564.69 747.26 1568.56 743.88 1572.41 740.94C1576.05 738.114 1579.93 735.612 1584 733.46C1587.65 731.522 1591.55 730.082 1595.58 729.18C1599.39 728.395 1603.29 728.169 1607.17 728.51C1611.03 728.83 1614.88 729.61 1618.73 730.27C1622.56 730.968 1626.43 731.442 1630.32 731.69C1634.19 731.953 1638.07 731.744 1641.89 731.07C1645.86 730.265 1649.74 729.073 1653.48 727.51C1657.34 725.97 1661.2 724.213 1665.05 722.24C1668.9 720.24 1672.77 718.07 1676.63 715.86C1680.49 713.65 1684.35 711.44 1688.21 709.22L1699.77 702.55L1711.36 695.86L1722.93 689.18L1734.51 682.49L1746.09 675.81L1757.67 669.12L1769.26 662.43L1780.83 655.75L1792.41 649.06L1804 642.37L1810.47 638.63"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1595.24 308.5L1560.78 328.39L1549.45 334.94L1537.81 341.66L1526.35 348.28L1514.77 355L1503 361.77L1491.43 368.45C1487.62 370.64 1483.91 372.79 1480.09 375L1468.5 381.67L1456.88 388.38L1445.24 395.1L1433.64 401.8L1422.05 408.49L1410.46 415.18L1398.88 421.87L1387.29 428.56L1375.72 435.24L1364.14 441.93L1352.55 448.62L1341 455.3L1329.39 462L1317.82 468.67C1313.94 470.89 1310.08 473.117 1306.24 475.35L1294.67 482L1283.09 488.69L1271.51 495.38L1260 502.08L1248.41 508.77L1236.83 515.46L1225.25 522.14L1213.68 528.82L1202 535.51L1190.43 542.19L1178.85 548.88L1167.27 555.56L1155.69 562.25L1144.11 568.94L1132.56 575.63L1124.5 580.28"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <text
        fill="#181A1B"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="20"
        fontWeight="800"
        letterSpacing="0em"
      >
        <tspan x="1474.05" y="606">
          IO
        </tspan>
      </text>
      <text
        fill="url(#paint2_linear_1112_10632)"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="76"
        fontWeight="800"
        letterSpacing="0em"
      >
        <tspan x="1404.1" y="679.6">
          52%
        </tspan>
      </text>
      <text
        fill="#181A1B"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="18"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="1447.2" y="710.8">
          Address:&#10;
        </tspan>
        <tspan x="1442.26" y="733.8">
          0x4553e0
        </tspan>
      </text>
      <g filter="url(#filter0_ddd_1112_10632)">
        <rect x="704" y="252" width="624" height="556" rx="12" fill="#1B2628" />
      </g>
      <rect opacity="0.3" x="704" y="473" width="624" height="24" fill="#FD0054" />
      <rect opacity="0.1" x="753" y="289" width="1" height="519" fill="white" />
      <text
        opacity="0.4"
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="728.592" y="320.938">
          6&#10;
        </tspan>
        <tspan x="728.592" y="341.938">
          7&#10;
        </tspan>
        <tspan x="728.592" y="362.938">
          8&#10;
        </tspan>
        <tspan x="728.592" y="383.938">
          9&#10;
        </tspan>
        <tspan x="720.184" y="404.938">
          10&#10;
        </tspan>
        <tspan x="720.184" y="425.938">
          11&#10;
        </tspan>
        <tspan x="720.184" y="446.938">
          12&#10;
        </tspan>
        <tspan x="720.184" y="467.938">
          13&#10;
        </tspan>
        <tspan x="720.184" y="488.938">
          14&#10;
        </tspan>
        <tspan x="720.184" y="509.938">
          15&#10;
        </tspan>
        <tspan x="720.184" y="530.938">
          16&#10;
        </tspan>
        <tspan x="720.184" y="551.938">
          17&#10;
        </tspan>
        <tspan x="720.184" y="572.938">
          18&#10;
        </tspan>
        <tspan x="720.184" y="593.938">
          19&#10;
        </tspan>
        <tspan x="720.184" y="614.938">
          20&#10;
        </tspan>
        <tspan x="720.184" y="635.938">
          21&#10;
        </tspan>
        <tspan x="720.184" y="656.938">
          22&#10;
        </tspan>
        <tspan x="720.184" y="677.938">
          23&#10;
        </tspan>
        <tspan x="720.184" y="698.938">
          24&#10;
        </tspan>
        <tspan x="720.184" y="719.938">
          25&#10;
        </tspan>
        <tspan x="720.184" y="740.938">
          26&#10;
        </tspan>
        <tspan x="720.184" y="761.938">
          27&#10;
        </tspan>
        <tspan x="720.184" y="782.938">
          28
        </tspan>
      </text>
      <path
        d="M704 264C704 257.373 709.373 252 716 252H1316C1322.63 252 1328 257.373 1328 264V288H704V264Z"
        fill="#1B2628"
      />
      <text
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="14"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="1012.04" y="274.9">
          C
        </tspan>
      </text>
      <circle cx="726" cy="270" r="6" fill="#FD0054" />
      <circle cx="746" cy="270" r="6" fill="#FFB31A" />
      <circle cx="766" cy="270" r="6" fill="#00CC21" />
      <rect opacity="0.1" x="704" y="288" width="624" height="1" fill="white" />
      <text
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="778" y="320.938">
          #
        </tspan>
        <tspan x="836.857" y="320.938">
          {' '}
        </tspan>
        <tspan x="920.939" y="320.938">
          {' '}
        </tspan>
        <tspan x="778" y="341.938" />
        <tspan x="803.225" y="362.938">
          {' '}
          visited[MAX_NODES];{' '}
        </tspan>
        <tspan x="778" y="383.938">
          {' '}
        </tspan>
        <tspan x="778" y="404.938" />
        <tspan x="811.633" y="425.938">
          {' '}
        </tspan>
        <tspan x="912.531" y="425.938">
          (Graph g,{' '}
        </tspan>
        <tspan x="1021.84" y="425.938">
          {' '}
          nV, Vertex src, Vertex dest)&#10;
        </tspan>
        <tspan x="778" y="446.938">
          {'{'}&#10;
        </tspan>
        <tspan x="778" y="467.938">
          {' '}
          Vertex v;&#10;
        </tspan>
        <tspan x="778" y="488.938">
          {' '}
        </tspan>
        <tspan x="836.857" y="488.938">
          {' '}
          (v ={' '}
        </tspan>
        <tspan x="895.715" y="488.938">
          ; v &#60; nV; v++) visited[v] = -
        </tspan>
        <tspan x="1147.96" y="488.938">
          ;&#10;
        </tspan>
        <tspan x="778" y="509.938" />
        <tspan x="778" y="530.938">
          {' '}
          visited[src] = src;&#10;
        </tspan>
        <tspan x="778" y="551.938">
          {' '}
          queue Q ={' '}
        </tspan>
        <tspan x="962.98" y="551.938">
          ();&#10;
        </tspan>
        <tspan x="778" y="572.938">
          {' '}
        </tspan>
        <tspan x="912.531" y="572.938">
          (Q, src);&#10;
        </tspan>
        <tspan x="778" y="593.938">
          {' '}
        </tspan>
        <tspan x="853.674" y="593.938">
          {' '}
          (!
        </tspan>
        <tspan x="979.797" y="593.938">
          (Q))&#10;
        </tspan>
        <tspan x="778" y="614.938">
          {' '}
          {'{'}&#10;
        </tspan>
        <tspan x="778" y="635.938">
          {' '}
          v ={' '}
        </tspan>
        <tspan x="979.797" y="635.938">
          (Q);&#10;
        </tspan>
        <tspan x="778" y="656.938">
          {' '}
          Vertex w;&#10;
        </tspan>
        <tspan x="778" y="677.938">
          {' '}
        </tspan>
        <tspan x="870.49" y="677.938">
          {' '}
          (w = 0; w &#60; nV; w++)&#10;
        </tspan>
        <tspan x="778" y="698.938">
          {' '}
        </tspan>
        <tspan x="895.715" y="698.938">
          {' '}
          (
        </tspan>
        <tspan x="979.797" y="698.938">
          (g, v, w) &#38;&#38; visited[w] == -
        </tspan>
        <tspan x="1223.63" y="698.938">
          )&#10;
        </tspan>
        <tspan x="778" y="719.938">
          {' '}
          {'{'}&#10;
        </tspan>
        <tspan x="778" y="740.938">
          {' '}
          visited[w] = v;&#10;
        </tspan>
        <tspan x="778" y="761.938">
          {' '}
        </tspan>
        <tspan x="929.348" y="761.938">
          {' '}
          (w == dest)&#10;
        </tspan>
        <tspan x="778" y="782.938">
          {' '}
        </tspan>
        <tspan x="996.613" y="782.938">
          {' '}
        </tspan>
        <tspan x="1038.65" y="782.938">
          ;
        </tspan>
      </text>
      <text
        fill="#FFD500"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="786.408" y="320.938">
          define
        </tspan>
        <tspan x="778" y="362.938">
          int
        </tspan>
        <tspan x="778" y="425.938">
          bool
        </tspan>
        <tspan x="996.613" y="425.938">
          int
        </tspan>
        <tspan x="811.633" y="488.938">
          for
        </tspan>
        <tspan x="811.633" y="593.938">
          while
        </tspan>
        <tspan x="845.266" y="677.938">
          for
        </tspan>
        <tspan x="878.898" y="698.938">
          if
        </tspan>
        <tspan x="912.531" y="761.938">
          if
        </tspan>
        <tspan x="946.164" y="782.938">
          return
        </tspan>
      </text>
      <text
        fill="#FD6A00"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="845.266" y="320.938">
          MAX_NODES
        </tspan>
        <tspan x="820.041" y="425.938">
          findPathBFS
        </tspan>
      </text>
      <text
        fill="#F14AFF"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="929.348" y="320.938">
          1000&#10;
        </tspan>
        <tspan x="887.307" y="488.938">
          0
        </tspan>
        <tspan x="1139.55" y="488.938">
          1
        </tspan>
        <tspan x="895.715" y="551.938">
          newQueue
        </tspan>
        <tspan x="811.633" y="572.938">
          QueueEnqueue
        </tspan>
        <tspan x="878.898" y="593.938">
          QueueIsEmpty
        </tspan>
        <tspan x="878.898" y="635.938">
          QueueDequeue
        </tspan>
        <tspan x="912.531" y="698.938">
          adjacent
        </tspan>
        <tspan x="1215.23" y="698.938">
          1
        </tspan>
        <tspan x="1005.02" y="782.938">
          true
        </tspan>
      </text>
      <text
        fill="#798486"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="988.205" y="362.938">
          // array to store visiting order&#10;
        </tspan>
        <tspan x="988.205" y="383.938">
          // indexed by vertex 0..nV-1&#10;
        </tspan>
      </text>
      <g clipPath="url(#clip1_1112_10632)">
        <path
          d="M1304 737.418C1304 736.207 1303.74 735.138 1303.21 734.22C1302.7 733.317 1301.93 732.56 1300.9 731.962C1292.38 727.044 1283.85 722.142 1275.33 717.219C1273.04 715.892 1270.81 715.941 1268.53 717.287C1265.14 719.289 1248.16 729.026 1243.1 731.959C1241.02 733.166 1240 735.014 1240 737.416C1240 747.305 1240 757.194 1240 767.084C1240 768.268 1240.25 769.317 1240.75 770.222C1241.26 771.152 1242.04 771.929 1243.1 772.541C1248.16 775.474 1265.14 785.211 1268.53 787.213C1270.81 788.56 1273.04 788.608 1275.33 787.281C1283.85 782.358 1292.38 777.456 1300.9 772.538C1301.96 771.926 1302.74 771.148 1303.25 770.219C1303.75 769.315 1304 768.266 1304 767.081C1304 767.081 1304 747.308 1304 737.418Z"
          fill="white"
        />
        <path
          d="M1278.61 747.742L1288.57 747.812C1288.57 743.662 1284.37 733.5 1272.33 733.5C1264.66 733.5 1254.34 738.378 1254.34 752.403C1254.34 766.427 1264.46 771 1272.33 771C1285.09 771 1288.13 762.175 1288.13 757.187L1278.63 756.644C1278.63 756.644 1278.89 762.412 1272.28 762.412C1266.18 762.412 1265.17 754.943 1265.17 752.403C1265.17 748.541 1266.54 742.341 1272.28 742.341C1278.02 742.341 1278.61 747.742 1278.61 747.742Z"
          fill="#181A1B"
        />
      </g>
      <path
        d="M1328 484L1486 484L1486 531M1486 531L1476.38 519.375M1486 531L1495.62 519.375"
        stroke="#181A1B"
        strokeWidth="2"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd_1112_10632"
        x="664"
        y="232"
        width="704"
        height="636"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_10632" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_10632"
          result="effect2_dropShadow_1112_10632"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_10632"
          result="effect3_dropShadow_1112_10632"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_10632"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_10632"
        x1="1610"
        y1="539"
        x2="1351.74"
        y2="550.189"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.248157" stopColor="#F14CFF" />
        <stop offset="0.873684" stopColor="#401AFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_10632"
        x1="1590"
        y1="559"
        x2="1373.4"
        y2="568.384"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.248157" stopColor="#F14CFF" />
        <stop offset="0.873684" stopColor="#401AFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_10632"
        x1="1566"
        y1="615"
        x2="1415.32"
        y2="709.126"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.202728" stopColor="#F14AFF" />
        <stop offset="0.888777" stopColor="#401AFF" />
      </linearGradient>
      <clipPath id="clip0_1112_10632">
        <rect width="1731" height="857" fill="white" />
      </clipPath>
      <clipPath id="clip1_1112_10632">
        <rect width="64" height="72" fill="white" transform="translate(1240 716)" />
      </clipPath>
    </defs>
  </svg>
);

CLang.propTypes = {
  className: PropTypes.string,
};

CLang.defaultProps = {
  className: null,
};

export default CLang;
